module.exports = __webpack_public_path__ + "static/Xml-b0b8990c86e7964575acc9ca90a37bb1.svg";